import { CreatedInterfaces } from 'interfaces';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'transactions';

const useGetTransaction = (trxId: string, cardId: string, cardHolderId: string, date: string, transactionType?: string) => {
  const [{ data, error, loading: isLoading }] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: `v2/transactions/${trxId}`,
  });

  let currentTransaction = data?.data?.find(
    (trx) =>
      trx?.authorization?.info?.card?.id === cardId &&
      trx?.authorization?.info?.card?.card_holder_id === cardHolderId &&
      trx?.authorization?.info?.transaction?.received_timestamp === date
  )

  if(["CASH_OUT", "TRANSFER_CREDIT", "TRANSFER_DEBIT"].includes(transactionType)){
    currentTransaction = data?.data?.find(
      (trx) =>
        trx?.authorization?.info?.transaction?.received_timestamp === date
    )
  }

  return {
    transaction: currentTransaction,
    isLoading,
    isError: error,
  };
};

export default useGetTransaction;
